export default function (data) {
  // Remove previous cssFlags implementation
  delete data.cssFlags;

  return {
    module: 'SHeadline',
    ...data,
    cssFlags: { ...data.cssFlagsResponsive, xs: data.cssFlagsResponsive.sm } || {}
  };
}
